<template>
  <DxTabPanel
    :element-attr="tabPanelAttributes"
    :data-source="salesSteps"
    :loop="false"
    :selected-item="currentItem"
    :selected-index="currentStep"
    :animation-enabled="true"
    :swipe-enabled="false"
    :show-nav-buttons="false"
    @selection-changed="tabSelectionChanged($event)"
  >
    <template #item="{ data: step }">
      <div>
        <DxScrollView ref="salesInputScroll" v-show="step == 1" class="sales-input-scroll" :use-native="true">
          <div class="sales_input_holder" :class="[{ input_holder_error: $v.salesData.sales_date.$error }]">
            <div @click="showCalendarSelector">
              <div class="input_label">{{ $t("common.date") }}</div>
              <div class="input_value">
                <span :style="{ color: 'inherit' }">{{ salesData.sales_date }}</span>
              </div>
            </div>
            <div v-if="is_date_selector_visible">
              <FunctionalCalendar
                :date-format="getDefaultDateFormat.toLowerCase()"
                :is-date-range="false"
                v-model="calendarData"
                :change-month-function="true"
                :change-year-function="true"
                :is-date-picker="true"
                @choseDay="calendarDayChosen"
                @input="onDateSelected"
              ></FunctionalCalendar>
            </div>
          </div>
          <div class="sales_input_holder" @click="contractsClick()">
            <div class="sales_parcel_select_edit">
              <div class="sales_parcel_info">
                <div class="input_label">{{ $t("stock_mobile.form.contract_number") }}</div>
                <div v-if="selectedContracts.length > 0" class="input_value">{{ getSelectedContracts }}</div>
                <div v-else class="input_value_placeholder" style="color: #989696 !important">{{ $t("stock_mobile.form.select_contract") }}</div>
              </div>
              <div class="sales_parcel_edit_icon" @click="contractsClick()">
                <i class="fa-regular fa-edit"></i>
              </div>
            </div>
          </div>
          <div
            class="sales_input_holder"
            @click="showProductSelector"
            :class="[{ input_holder_error: $v.salesData.products.$error }]"
          >
            <div class="sales_parcel_select_edit">
              <div class="sales_parcel_info">
                <div class="input_label">{{ $t("common.product") }}</div>
                <div v-if="salesData.products.length > 0" class="input_value">{{ getSelectedProduse() }}</div>
                <div v-else class="input_value_placeholder" style="color: #989696 !important">{{ $t("stock_mobile.form.select_product") }}</div>
                <div v-if="selectedProductWarehouseName" class="sales_input_second_value">
                  {{ $t("common.warehouse") }}: {{ selectedProductWarehouseName }}
                </div>
              </div>
              <div class="sales_parcel_edit_icon" @click="showProductSelector">
                <i class="fa-regular fa-edit"></i>
              </div>
            </div>
          </div>
          <div class="sales_input_holder" :class="[{ input_holder_error: $v.salesData.partner.uuid.$error }]">
            <div v-if="selectedContracts.length > 0">
              <div class="input_label">{{ $t("stock_mobile.form.client") }}</div>
              <DxTextBox :value="salesData.partner.name" :read-only="true" class="global_dx_textbox" />
            </div>
            <div v-else class="sales_parcel_select_edit" @click="partnerClick">
              <div class="sales_parcel_info">
                <div class="input_label">{{ $t("stock_mobile.form.client") }}</div>
                <div v-if="salesData.partner.name" class="input_value">{{ salesData.partner.name }}</div>
                <div v-else class="input_value_placeholder" style="color: #989696 !important">
                  {{ $t("stock_mobile.form.select_client") }}
                </div>
              </div>
              <div class="sales_parcel_edit_icon"><i class="fa-regular fa-edit"></i></div>
            </div>
          </div>

          <div class="sales_input_holder">
            <div class="input_label">{{ $t("common.notes") }}</div>
            <div class="input_value">
              <DxTextArea v-model="salesData.notes" class="global_dx_number_input" />
            </div>
          </div>
          <div class="input-bottom-spacer"></div>
        </DxScrollView>
        <div v-if="false" v-show="step == 2" class="scanner_area">
          <div>{{ $t("common.feature_in_development") }}</div>
          <br />
          <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader><br />
          <div>{{ $t("stock_mobile.form.scanned_code") }}</div>
          <b></b>
          <div>{{ scannedCode }}</div>
        </div>
        <div v-if="step == 3" class="reception_step_map">
          <ContractsPurchaseSaleSelector
            v-if="step == 3"
            :multiselect="true"
            :selectedContracts.sync="selectedContracts"
            :filterData="{
              contract_type_id: '2',
              show_completed_rows: 0,
              sale_type: 'partner',
            }"
            :toastMessageRef="$refs.toastMessage"
          />
        </div>
        <div v-if="step == 4" class="reception_step_map">
          <PartnerSelector
            v-if="step == 4"
            :allowAddNew="true"
            :multiselect="false"
            :selectedPartners.sync="selectedPartners"
            :toastMessageRef="$refs.toastMessage"
          />
        </div>
        <div class="reception_bottom_sticky" v-show="step == 3 && selectedContracts.length > 0">
          <div class="sticky_action_button" @click="continueFromSelection">{{ $t("common.continue") }}</div>
        </div>
        <div class="reception_bottom_sticky" v-show="step == 4 && selectedPartners.length > 0">
          <div class="sticky_action_button" @click="continueFromPartnerSelection">{{ $t("common.continue") }}</div>
        </div>
        <div class="sales_bottom_sticky_two_line" v-show="step == 1 && showSaveButtons && productsDataValid && !saveButtonPressed">
          <div class="sticky_action_button" @click="saveSales(true)">{{ $t("stock_mobile.form.save_and_new_sale") }}</div>
          <div class="sticky_action_button_second" @click="saveSales(false)">{{ $t("common.save") }}</div>
        </div>
        <div class="reception_bottom_sticky" v-show="step == 1 && canOpenProductSelector && !productsDataValid">
          <div class="sticky_action_button" @click="showProductSelector">{{ $t("common.continue") }}</div>
        </div>
        <ProductSelectorMultiManager
          ref="productSelector"
          :showPopup="productSelectorVisibility"
          @hidden="hideProductSelector"
          @input="applyProductsSelection"
          :selectedProducts="salesData.products"
          :selectFromStock="true"
          :allowAddNew="false"
          :filterData="filterData"
          :movementDate="salesData.sales_date"
          :transactionType="$t('stock_mobile.form.product_sale')"
          :showWarehouseSelector="true"
          :isProductEditable="true"
          :showUnitPrice="true"
        >
        </ProductSelectorMultiManager>
        <toast-message ref="toastMessage"></toast-message>
      </div>
    </template>
  </DxTabPanel>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DxTabPanel from "devextreme-vue/tab-panel";
import { DetailCodes, InputDetailCodes } from "./reception.js";
import { required, helpers } from "vuelidate/src/validators";
import DxTextBox from "devextreme-vue/text-box";
import { DxScrollView } from "devextreme-vue/scroll-view";
import ToastMessage from "@/components/Mobile/toastMessage.vue";
import DxTextArea from "devextreme-vue/text-area";
import { StreamBarcodeReader } from "vue-barcode-reader";
import { FunctionalCalendar } from "vue-functional-calendar";
import moment from "moment";
import { extractErrorMessage } from "@/helpers/generalActions";
import ContractsPurchaseSaleSelector from "@/components/Mobile/ContractsPurchaseSaleSelector.vue";
import PartnerSelector from "@/components/Mobile/PartnerSelector.vue";
import ProductSelectorMultiManager from "../Product/ProductSelectorMultiManager.vue";

const greaterThanZero = (value) => {
  return helpers.req(value) && value > 0;
};

export default {
  name: "Sales",
  data() {
    return {
      preselectDate: true,
      calendarData: {},
      salesSteps: [1, 2, 3, 4],
      currentStep: 0,
      currentItem: 1,
      tabPanelAttributes: {
        class: "sales_tabs",
      },
      detailStepCode: "",
      detailInputStepCode: "",
      salesData: {
        products: [],
        partner: {
          uuid: "",
          name: "",
          cui: "",
        },
        notes: "",
        sales_date: null,
      },
      warehouses: [],
      scannedCode: null,
      is_date_selector_visible: false,
      saveButtonPressed: false,
      selectedContracts: [],
      selectedPartners: [],
      contractProductFull: null,
      filterData: {},
      productSelectorVisibility: false,
    };
  },
  computed: {
    ...mapGetters({
      getDefaultDateFormat: "settings/getDefaultDateFormat",
    }),
    canOpenProductSelector() {
      return !!this.salesData.sales_date;
    },
    selectedProductWarehouseName() {
      return [...new Set(this.salesData.products.map((product) => product.warehouse_name).filter(Boolean))].join(", ");
    },
    productsDataValid() {
      if (!Array.isArray(this.salesData.products) || this.salesData.products.length === 0) {
        return false;
      }

      return this.salesData.products.every((product) => {
        const unitPrice = parseFloat(product?.unit_price);
        if (!product?.warehouse_uuid || !Number.isFinite(unitPrice) || unitPrice < 0) {
          return false;
        }
        const qty = parseFloat(product?.quantity) || 0;
        const max = parseFloat(product?.warehouse_quantity);
        if (qty <= 0) {
          return false;
        }
        if (Number.isFinite(max) && qty > max) {
          return false;
        }

        if (!product?.lot_management) {
          return true;
        }

        const items = Array.isArray(product.lot_items) ? product.lot_items : [];
        if (items.length === 0) {
          return false;
        }

        const sum = items.reduce((acc, item) => acc + (parseFloat(item.quantity) || 0), 0);
        if (sum <= 0 || Math.abs(sum - qty) > 0.0001) {
          return false;
        }

        return items.every((item) => (parseFloat(item.quantity) || 0) > 0);
      });
    },
    showSaveButtons() {
      return (
        this.salesData.products.length > 0 ||
        (this.salesData.partner.uuid && this.salesData.partner.uuid.length > 0) ||
        (this.salesData.notes && this.salesData.notes.length > 0)
      );
    },
    detailCodes() {
      return DetailCodes;
    },
    inputDetailCodes() {
      return InputDetailCodes;
    },
    getSelectedContracts() {
      if (this.selectedContracts && this.selectedContracts.length > 0) {
        const uniqueNumbers = [...new Set(this.selectedContracts.map((c) => c.contract_number))];
        return uniqueNumbers.join(", ");
      }
      return "";
    },
  },
  validations() {
    return {
      salesData: {
        sales_date: { required },
        products: {
          required,
          $each: {
            uuid: { required },
            warehouse_uuid: { required },
            quantity: { greaterThanZero },
          },
        },
        partner: {
          uuid: { required },
        },
      },
    };
  },
  components: {
    DxTabPanel,
    DxTextBox,
    DxScrollView,
    ToastMessage,
    DxTextArea,
    StreamBarcodeReader,
    FunctionalCalendar,
    ContractsPurchaseSaleSelector,
    PartnerSelector,
    ProductSelectorMultiManager,
  },
  methods: {
    ...mapActions({
      getProducts: "smProducts/getSmProducts",
      getWarehouses: "smWarehouses/getSmWarehouses",
      createSales: "smTransactions/createSalesTransaction",
      getGroupByCode: "settings/getGroupByCode",
    }),

    onLoaded() {},
    onDecode(result) {
      this.scannedCode = result;
      console.log("barcode result ", result);
    },
    tabSelectionChanged(e) {
      this.currentItem = e.addedItems[0];
      this.currentStep = this.salesSteps.indexOf(this.currentItem);
      this.changeAddButtonVisibility();
    },
    goBack() {
      if (this.currentStep > 0) {
        this.currentStep = 0;
        this.setTitle();
      } else {
        this.$emit("goBackParent");
      }
    },
    setTitle() {
      if (this.currentStep == 0) {
        this.$emit("setTitle", this.$t("stock_mobile.form.product_sale"), true);
      } else if (this.currentStep == 2) {
        this.$emit("setTitle", this.$t("stock_mobile.form.contracts"), true);
      } else if (this.currentStep == 3) {
        this.$emit("setTitle", this.$t("stock_mobile.form.client"), true);
      }
    },
    changeAddButtonVisibility() {
      //this.$emit('changeAddButtonVisibility', this.currentStep == 1 && this.detailStepCode != this.detailCodes.Warehouse);
      this.$emit("changeAddButtonVisibility", false);
    },
    saveSales(saveAndNew) {
      this.saveButtonPressed = true;
      this.$v.salesData.$touch();
      if (!this.$v.salesData.$invalid && this.productsDataValid) {
        const overStockProduct = this.salesData.products.find((product) => {
          const quantity = parseFloat(product?.quantity) || 0;
          const max = parseFloat(product?.warehouse_quantity);
          return Number.isFinite(max) && quantity > max;
        });
        if (overStockProduct) {
          this.saveButtonPressed = false;
          this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_quantity_exceeds_stock"));
          return;
        }

        const invalidLotProduct = this.salesData.products.find((product) => {
          if (!product?.lot_management) {
            return false;
          }
          const items = Array.isArray(product.lot_items) ? product.lot_items : [];
          const sum = items.reduce((acc, item) => acc + (parseFloat(item.quantity) || 0), 0);
          const quantity = parseFloat(product.quantity) || 0;
          return (
            items.length === 0 ||
            sum <= 0 ||
            Math.abs(sum - quantity) > 0.0001 ||
            items.some((item) => (parseFloat(item.quantity) || 0) <= 0)
          );
        });
        if (invalidLotProduct) {
          this.saveButtonPressed = false;
          this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_lot_sum_must_match"));
          return;
        }

        const partnerForSave = {
          uuid: this.salesData.partner.uuid.startsWith("NEW_") ? "" : this.salesData.partner.uuid,
          legal_form: this.salesData.partner.legal_form ?? "SRL",
          name: this.salesData.partner.name,
          id_number: this.salesData.partner.cui,
        };
        const salesForSave = {
          notes: this.salesData.notes,
          sales_date: this.salesData.sales_date,
          products: this.salesData.products.map((product) => ({
            uuid: product.uuid.toString().startsWith("NEW_") ? "" : product.uuid,
            barcode: product.barcode ?? null,
            name: product.name,
            quantity: parseFloat(product.quantity),
            unit_price: parseFloat(product.unit_price),
            warehouse_uuid: product.warehouse_uuid,
            department_uuid: this.getWarehouseDepartmentByWarehouseUuid(product.warehouse_uuid),
            lot_items: Array.isArray(product.lot_items) ? product.lot_items : [],
            partner: partnerForSave,
            contract_uuid: product.contract_uuid ?? null,
          })),
        };
        this.createSales(salesForSave)
          .then(() => {
            this.$refs.toastMessage.showSuccess(this.$t("stock_mobile.form.sale_saved"));
            if (saveAndNew) {
              this.resetForm();
              this.saveButtonPressed = false;
            } else {
              this.closeTransactions(this.$t("stock_mobile.form.sale_saved"));
            }
          })
          .catch((e) => {
            this.saveButtonPressed = false;
            console.log("sales error ", e);
            this.$refs.toastMessage.showError(extractErrorMessage(this, e));
          });
      } else {
        this.saveButtonPressed = false;
        this.$refs.toastMessage.showError(this.createErrormMssages());
      }
    },
    createErrormMssages() {
      let errorMessages = [];

      if (this.$v.salesData.sales_date.$invalid) {
        errorMessages.push(this.$t("stock_mobile.form.error_sale_date_required"));
      }
      if (this.$v.salesData.products.$invalid) {
        if (this.salesData.products.length === 0) {
          errorMessages.push(this.$t("stock_mobile.form.error_product_required"));
        } else if (this.salesData.products.some((product) => !product.warehouse_uuid)) {
          errorMessages.push(this.$t("stock_mobile.form.error_warehouse_required"));
        } else {
          errorMessages.push(this.$t("stock_mobile.form.error_quantity_gt_zero"));
        }
      }
      this.salesData.products.forEach((product) => {
        const quantity = parseFloat(product.quantity) || 0;
        const max = parseFloat(product.warehouse_quantity);
        const unitPrice = parseFloat(product.unit_price);
        if (!product.warehouse_uuid) {
          errorMessages.push(this.$t("stock_mobile.form.error_warehouse_required"));
        }
        if (quantity <= 0) {
          errorMessages.push(this.$t("stock_mobile.form.error_quantity_gt_zero_for", { name: product.name }));
        }
        if (!Number.isFinite(unitPrice) || unitPrice < 0) {
          errorMessages.push(this.$t("stock_mobile.form.error_unit_price_gte_zero_for", { name: product.name }));
        }
        if (Number.isFinite(max) && quantity > max) {
          errorMessages.push(this.$t("stock_mobile.form.error_quantity_exceeds_stock_for", { name: product.name }));
        }
      });
      if (this.$v.salesData.partner.uuid.$invalid) {
        errorMessages.push(this.$t("stock_mobile.form.error_supplier_required"));
      }
      if (this.$v.salesData.partner.cui.$invalid) {
        errorMessages.push(this.$t("stock_mobile.form.error_cui_required"));
      }

      return errorMessages;
    },
    goForward() {
      if (this.currentStep < 1) {
        this.currentStep = this.currentStep + 1;
        this.setTitle();
      }
    },
    contractsClick() {
      this.currentStep = 2;
      this.setTitle();
    },
    continueFromSelection() {
      this.currentStep = 0;
      this.setTitle();

      if (this.selectedContracts.length > 0) {
        const contracts = [...this.selectedContracts];
        const selectedContract = contracts[0];

        this.$set(this.salesData, "partner", {
          uuid: selectedContract.partner_uuid,
          name: selectedContract.partner_name,
          cui: selectedContract.partner_id_number ?? "",
          legal_form: selectedContract.partner_legal_form ?? "SRL",
        });
        this.contractProductFull = null;
        this.salesData.products = [];

        // Fetch full product to get stock_list so the warehouse selector inside the product editor is populated
        Promise.all(
          contracts.map((contract) =>
            this.getProducts({
              name: contract.product_name,
              has_stock: 1,
              enablePagination: 0,
            }).then((response) => {
              const list = Array.isArray(response?.data) ? response.data : Array.isArray(response) ? response : [];
              const product = list.find((item) => item.uuid === contract.product_uuid) || null;
              return product ? this.buildContractProductEntry(product, contract) : null;
            }),
          ),
        ).then((products) => {
          this.contractProductFull = products.filter(Boolean);
          this.salesData.products = this.contractProductFull;
        });
      }
    },
    partnerClick() {
      this.currentStep = 3;
      this.setTitle();
    },
    continueFromPartnerSelection() {
      this.currentStep = 0;
      this.setTitle();

      const selectedPartner = this.selectedPartners[0];
      if (!selectedPartner?.uuid) {
        return;
      }
      this.setSalesPartner(selectedPartner);
    },
    setSalesPartner(partner) {
      this.salesData.partner = {
        uuid: partner.uuid,
        name: partner.name,
        cui: partner.id_number ?? "",
        legal_form: partner.legal_form ?? "SRL",
      };
    },
    resetForm() {
      this.$v.$reset();
      this.contractProductFull = null;
      this.selectedContracts = [];
      this.selectedPartners = [];
      this.salesData.products = [];

      this.salesData.notes = "";

      this.$refs["salesInputScroll"].instance.scrollTo(0);
    },
    closeTransactions(message) {
      this.$emit("closeTransactions", message);
    },
    showProductSelector() {
      if (!this.salesData.sales_date) {
        this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_sale_date_required"));
        return;
      }
      this.productSelectorVisibility = true;
    },
    hideProductSelector() {
      this.productSelectorVisibility = false;
    },
    applyProductsSelection(products) {
      const list = Array.isArray(products) ? products : [];
      this.salesData.products = list;
    },
    getSelectedProduse() {
      if (this.salesData.products.length > 0) {
        const labels = this.salesData.products.slice(0, 2).map((product) => {
          const symbol = product.measure_unit?.symbol ?? "";
          const qty = parseFloat(product.quantity) || 0;
          return product.name + (qty > 0 ? " - " + qty + " " + symbol : "");
        });
        if (this.salesData.products.length > 2) {
          labels.push(this.$t("stock_mobile.form.more_products_count", { count: this.salesData.products.length - 2 }));
        }
        return labels.join(", ");
      }
      return this.$t("stock_mobile.form.select_product");
    },
    buildContractProductEntry(product, selectedContract) {
      // Restrict warehouse options to the contract's legal entity, if set
      const stockList = (Array.isArray(product.stock_list) ? product.stock_list : []).filter(
        (s) =>
          s.quantity > 0 &&
          (!selectedContract.legal_entity_uuid || s.legal_entity_uuid === selectedContract.legal_entity_uuid)
      );
      return {
        uuid: product.uuid,
        name: product.name,
        code: product.code ?? null,
        product_name_code: product.code ? product.name + " (" + product.code + ")" : product.name,
        measure_unit: product.measure_unit ?? null,
        measure_unit_id: product.measure_unit?.id ?? null,
        quantity: selectedContract.remaining_quantity || null,
        unit_price: 0,
        contract_uuid: selectedContract.uuid,
        contract_legal_entity_uuid: selectedContract.legal_entity_uuid,
        lot_management: product.lot_management ?? false,
        lot_items: [],
        warehouse_uuid: null,
        warehouse_name: "",
        warehouse_quantity: null,
        stock_list: stockList,
      };
    },
    showCalendarSelector() {
      this.is_date_selector_visible = !this.is_date_selector_visible;
    },
    calendarDayChosen(data) {
      this.is_date_selector_visible = false;
    },
    onDateSelected(date) {
      this.salesData.sales_date = date.selectedDate;
    },
    getWarehouseDepartmentByWarehouseUuid(warehouseUuid) {
      let warehouse = this.warehouses.find((w) => w.uuid == warehouseUuid);
      if (warehouse) {
        return warehouse.department_uuid;
      }
      return null;
    },
  },
  mounted() {
    this.getGroupByCode({
      code: "STOCK_MANAGEMENT",
    }).then((response) => {
      let _setting = response.items.find((obj) => obj.code == "USE_CURRENT_DATE_ON_CREATION");
      this.preselectDate = _setting?.value == "1";
      if (this.preselectDate) {
        this.salesData.sales_date = moment().format(this.getDefaultDateFormat);
      }
    });
    this.setTitle();
    this.getWarehouses({
      enablePagination: 0,
      limit: 1000,
      filter: [["is_active", "=", 1]],
    }).then((response) => {
      this.warehouses = response.data;
    });
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/stockMobile/sales.scss";
</style>
